import { getCsfrToken } from '../../utils';
export async function addToFavorite(isAuth, loginUrl, url, productId, callback) {
    if (!isAuth) {
        window.location.href = loginUrl;
        return;
    }
    try {
        const response = await fetch(`${url}/${productId}`, {
            method: 'GET',
            headers: {
                'X-CSRF-TOKEN': getCsfrToken(),
            },
        });
        const result = await response.text();
        callback(result === 'true');
    }
    catch (error) {
        console.log(error);
    }
}
